import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { fetchUserProfile } from "../../../actions/student.action";
import { useDispatch, useSelector } from "react-redux";
import RoundLoader from "../../../components/loader/RoundLoader";
import { Loading } from "../../../utils/helpers/constants";

export default function MemberProfile() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const memberId = location.state.id;

  useEffect(() => {
    dispatch(fetchUserProfile(memberId));
  }, []);

  const {
    student: { studentProfile, studentProfileLoading },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  const profileState = studentProfileLoading === Loading.FETCHING;

  console.log("studentProfile.addresses ", studentProfile.addresses);
  return (
    <div>
      {profileState ? (
        <RoundLoader />
      ) : (
        <>
          <div className="doc_processing_color h-40 px-4 pt-6">
            <AiOutlineArrowLeft
              size={25}
              onClick={() => history.goBack()}
              className="mb-2"
            />
            <div className="text-md">
              <span className="text-2xl text-green-800 font-serif font-bold">
                Member Profile
              </span>
            </div>
            <div className="text-md">Member profile</div>
          </div>

          <div className="p-4">
            <div className="flex items-cente">
              <img
                className="w-32 h-32 mr-4 rounded"
                src={
                  "https://images.unsplash.com/photo-1590608897129-79da98d15969?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fHdlYiUyMGRldmVsb3BtZW50fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
                }
                alt="profile_picture"
              />
              <div className="">
                <div className="text-gray-400 font-bold">
                  {studentProfile.officeType}
                </div>
                <div className="text-gray-900 text-2xl">
                  {studentProfile.fullName}
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-5">
              <div className="text-gray-400 font-bold">About</div>
            </div>
            <div className="mb-2">{studentProfile.bio}</div>
            <div className="flex justify-between mt-2">
              <div className="text-gray-400 font-bold">Contact</div>
            </div>
            <div className="mt-0">
              <div>
                {studentProfile.addresses !== undefined && (<>
                  {studentProfile.addresses.length !== 0
                  ? studentProfile.addresses[0].locationAddress
                  : ""}
                </>
                )}
              </div>
              <div>{studentProfile.phoneNumber}</div>
            </div>

            <div className="flex justify-between mt-0">
              <div className="text-gray-400 font-bold">History</div>
            </div>
            <div className="mb-2">
              <div></div>
            </div>

            <div className="flex justify-between mt-">
              <div className="text-gray-400 font-bold">Achievements</div>
            </div>
            <div className="mb-2">
              <div></div>
            </div>

            <div className="flex justify-between mt-0">
              <div className="text-gray-400 font-bold">Projects Done</div>
            </div>
            <div className="mb-2">
              <div></div>
              <div></div>
            </div>

            <div className="flex justify-between">
              <div className="text-gray-400 font-bold"></div>
            </div>
            <div className="mb-2">
              <div></div>
              <div></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
